import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { SchoolServices } from '../../services';
import { ConfigurationServices } from '../../../configuration/services';
import { ClassroomsViewPage } from '../../classrooms-view/classrooms-view';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuCreateDishSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-classrooms-create-students-select',
  templateUrl: 'classrooms-create-students-select.html',
})
export class ClassroomsCreateStudentsSelectPage {

  update_state: boolean = false;
  classroom_uid: string = '';
  classroom: any;
  next_page: boolean = false;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public toastCtrl: ToastController,
    public schoolServices: SchoolServices,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService) {

    this.update_state = this.navParams.get('update_state');
    this.classroom_uid = this.navParams.get('classroom_uid');
    this.classroom = this.navParams.get('classroom');

  }

  onBack() {
    this.next_page = true;
    this.navCtrl.pop();
  }

  ionViewDidLeave() {
    if (this.update_state && !this.next_page) {
      this.schoolServices.classroom_teachers_array_tmp = Array(); //Limpiamos el array
      this.schoolServices.classroom_students_array_tmp = Array(); //Limpiamos el array
    }
  }

  loadingPopup: any;
  async finishClassroomCreate() {
    this.next_page = true;

    if (this.schoolServices.classroom_students_array_tmp.length == 0) {
      var toast = this.toastCtrl.create({
        message: this.translate.instant('instant-intoduce-un-alumno'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {

      if (this.update_state) {
        this.loadingPopup = this.loadingCtrl.create({
          spinner: 'crescent',
          content: this.translate.instant('instant-editando-curso')
        });
        this.loadingPopup.present();
      } else {
        this.loadingPopup = this.loadingCtrl.create({
          spinner: 'crescent',
          content: this.translate.instant('instant-creando-curso')
        });
        this.loadingPopup.present();
      }

      //Preparamos el objecto para insertarlo
      var _obj = {};
      for (var i = 0; this.schoolServices.classroom_students_array_tmp.length > i; i++) {

        _obj[i] = {
          uid_restaurant: this.schoolServices.classroom_students_array_tmp[i][0],
          name: this.schoolServices.classroom_students_array_tmp[i][1],
          email: this.schoolServices.classroom_students_array_tmp[i][2],
        };
      }

      //await this.schoolServices.insertStudentsInTeachers();

      //update info que falta fb classrom
      this.schoolServices.afs.collection('classrooms').doc(this.classroom_uid).update({
        'students_list': _obj,
        'updated_at': new Date(),
      }).then(async () => {

        if (this.update_state) {
          this.classroom.students_list = _obj;
        } else {
          this.classroom = await this.schoolServices.getClassroom(this.classroom_uid);
        }


        this.schoolServices.classroom_teachers_array_tmp = Array(); //Limpiamos el array
        this.schoolServices.classroom_students_array_tmp = Array(); //Limpiamos el array
        this.loadingPopup.dismiss();
        this.navCtrl.setRoot(ClassroomsViewPage, {
          classroom: this.classroom,
        });
      });
    }

  }



}


// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-students-select/classrooms-create-students-select.ts